import classNames from "classnames";
import { DonutChart } from "../primitives";
import styles from "./style.module.scss";

interface RingLegendProps {
  /** Share of the ring that is filled, 0-1. */
  ratio: number;
  /** Label for the filled part. */
  legendA: string;
  /** Label for the remainder. */
  legendB: string;
  size?: number;
  className?: string;
}

const FILL = "#9a469b";
const TRACK = "#f1eef2";

/** Small progress ring with its two-line legend, used by the headline tiles. */
function RingLegend({
  ratio,
  legendA,
  legendB,
  size = 76,
  className,
}: RingLegendProps) {
  // Never let a real-but-tiny share disappear entirely.
  const share = Math.max(1.5, Math.min(100, ratio * 100));

  return (
    <div className={classNames(styles.ring, className)}>
      <DonutChart
        size={size}
        thickness={14}
        trackColor={TRACK}
        slices={[{ label: legendA, share, color: FILL }]}
        center={
          <span className={styles.ringPct}>
            {`${(ratio * 100).toFixed(ratio < 0.1 ? 1 : 0)}%`}
          </span>
        }
      />
      <div className={styles.ringLegend}>
        <span className={styles.legendRow}>
          <span className={styles.dot} style={{ background: FILL }} />
          {legendA}
        </span>
        <span className={styles.legendRow}>
          <span className={styles.dot} style={{ background: TRACK }} />
          {legendB}
        </span>
      </div>
    </div>
  );
}

export default RingLegend;
